const GENERIC_IDENTITY_LABELS = new Set([
  'pac account',
  'signed in user',
  'oidc_user',
]);

function normalizeLabel(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

function looksLikeNumericId(label: string): boolean {
  return /^#?\d+$/.test(label);
}

function looksLikeEmail(label: string): boolean {
  return label.includes('@');
}

function isGenericIdentity(label: string): boolean {
  return GENERIC_IDENTITY_LABELS.has(label.toLowerCase());
}

export function isSafeTenantLabel(value: unknown): value is string {
  const label = normalizeLabel(value);
  if (!label) return false;
  if (looksLikeNumericId(label)) return false;
  if (looksLikeEmail(label)) return false;
  if (isGenericIdentity(label)) return false;
  return true;
}

export function resolveTenantLabel(...candidates: unknown[]): string | null {
  for (const candidate of candidates) {
    if (isSafeTenantLabel(candidate)) return candidate.trim();
  }
  return null;
}
